export default function freeze(obj: {[key: string]: any}, {deep = true}: {deep?: boolean} = {}) {
  const type = obj.constructor.name;

  if (type !== `Object` && type !== `Array`) {
    // reject Sets, Maps, Dates, etc. since they will be silently mutable after Object.freeze
    throw new TypeError(`${type} cannot be frozen via Object.freeze`);
  }

  Object.freeze(obj);

  if (deep) {
    Object.getOwnPropertyNames(obj).forEach((propName) => {
      const prop = obj[propName];
      if (typeof prop === `object` && !Object.isFrozen(prop)) {
        freeze(prop);
      }
    });
  }

  return obj;
}
